"use client";

import { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import React from "react";

type Props = {
  children?: React.ReactNode;
  session?: Session | null;
};

export const NextAuthProvider = (props: Props) => {
  const { children, session } = props;
  return <SessionProvider session={session}>{children}</SessionProvider>;
};
